module.exports = __webpack_public_path__ + "media/src/img/payment/g-pay-group-50678d7f92ae372c520ea7abc9159aad.svg";